// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { OpportunityModelRequest } from '../Classes/OpportunityModelRequest';
export class OpportunityModel extends OpportunityModelRequest {
  opportunityType: string;
  owner: string;
  ownerId: string;
  modifiedBy: string;
  plOpportunitySource: string;
  salesStage: string;
  integrationId: string;
  plArea: string;
  plZone: string;
  plProjectCategory: string;
  baseOpportunityID: string;
  currency: string;
  oppSalesOfficeNum: string;
  minMargin: number;
  gckCode: string;
  type: string;
}
